import { accountService } from '@/services/AccountService';

class CurrencyService {
  getCurrency(workspaceId: number): Promise<string> {
    return new Promise(resolve => {
      let currency = '';
      try {
        currency = localStorage.getItem(`currency-${workspaceId}`) || '';
      } catch (e) {}
      if (!currency) {
        accountService
          .getBalance(workspaceId)
          .then((data: any) => {
            localStorage.setItem(`currency-${workspaceId}`, data.currency);
            resolve(data.currency || '');
          })
          .catch(() => {
            resolve('');
          });
      } else {
        resolve(currency);
      }
    });
  }
}

export const currencyService = new CurrencyService();
